import React, { useState, useEffect, Fragment } from 'react';
import { ApolloProvider } from '@material-bank/apollo-client';
import { CustomerProvider } from '@material-bank/customer';
import { ProjectsCustomerProvider } from '@material-bank/projects-utils';
import { App } from '@mb/App';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { Provider } from 'react-redux';
import { ProjectModalListener } from './components/ProjectsModal';
import { MiniPdpView } from './containers/MiniPdpView/MiniPdpView';
import store from './redux/store';
import { ClickedMaterialProps } from './types/details';

const defaultProps = {
  currentMaterialId: undefined,
  currentMaterial: undefined,
  clickedProductGridIndex: undefined,
  clickedProductRequestId: undefined,
  isProduct: false,
  isMaterial: false,
  learnMoreNewTab: false,
  dataLayerAnalytics: undefined,
};

const MiniPDPContainer = () => {
  const [clickedMaterialData, setClickedMaterialData] =
    useState<ClickedMaterialProps>(defaultProps);

  useEffect(() => {
    window.addEventListener('initMiniPDP', handleInitMiniPDP);
    return () => {
      window.removeEventListener('initMiniPDP', handleInitMiniPDP);
    };
  }, []);

  const handleInitMiniPDP = (e: CustomEvent) => {
    if (e.detail?.id != null) {
      setClickedMaterialData({
        currentMaterialId: e.detail.id,
        currentMaterial: e.detail.product,
        clickedProductGridIndex: e.detail.clickedProductGridIndex,
        clickedProductRequestId: e.detail.clickedProductRequestId,
        isProduct: e.detail?.isProduct,
        isMaterial: e.detail?.isMaterial,
        learnMoreNewTab: e.detail?.learnMoreNewTab,
        clickedProductAnalyticsClass: e.detail?.clickedProductAnalyticsClass,
        clickedProductAnalyticsImpressions:
          e.detail?.clickedProductAnalyticsImpressions,
        dataLayerAnalytics: e.detail?.dataLayerAnalytics,
      });
    }
  };

  const handleClose = () => {
    setClickedMaterialData(defaultProps);
    // fix for page scroll on modal close
    setTimeout(() => {
      document?.getElementById('html-body')?.removeAttribute('style');
    }, 400);
  };

  if (!clickedMaterialData?.currentMaterialId) {
    return <Fragment />;
  }

  return (
    <App>
      <IntlProvider>
        <ApolloProvider>
          <ProjectsCustomerProvider>
            <CustomerProvider>
              <Provider store={store}>
                <MiniPdpView
                  onModalClose={handleClose}
                  clickedMaterialData={clickedMaterialData}
                />
                <ProjectModalListener />
              </Provider>
            </CustomerProvider>
          </ProjectsCustomerProvider>
        </ApolloProvider>
      </IntlProvider>
    </App>
  );
};

export default MiniPDPContainer;
